<template>
  <div class="container">
    <!-- <div style="padding:15px 17.5px 25px 17.5px;font-size: 16px;color: #3C3C3C;    font-family: PingFangSC-Regular, sans-serif;">
            <div style="padding-bottom:8px;">1.对方可以免费领取<font style="color:#01ADE7;">3</font>天VIP；</div>
            <div style="padding-bottom:8px;">2.你每邀请<font style="color:#01ADE7;">1</font>人可以得1天VIP，最多得<font style="color:#01ADE7;">90</font>天，邀请人数上不封顶；</div>
            <div>3.你邀请的人开通VIP 你有现金奖励，一级<font style="color:#01ADE7;">30</font>元，二级<font style="color:#01ADE7;">6</font>元</div>
        </div> -->
    <div>
      <p>1.对方可以免费领取<font style="color:#01ADE7;">3</font>天VIP；</p>
      <p>
        2.你每邀请1人可以得<font style="color:#01ADE7;">1</font
        >天VIP，最多得<font style="color:#01ADE7;">90</font
        >天，邀请人数上不封顶；
      </p>
      <p>
        3.你邀请的人开通VIP 你有现金奖励，一级<font style="color:#01ADE7;"
          >30</font
        >元，二级<font style="color:#01ADE7;">6</font>元
      </p>
    </div>
    <!-- <font color='#01ADE7'>3</font>天VIP；<br/> \n "
        + "2.你每邀请1人可以得<font color='#01ADE7'>1</font>天VIP，最多得90天，邀请人数上不封顶；<br/>\n "
        + "3.你邀请的人开通VIP 你有现金奖励，一级<font color='#01ADE7'>30</font>元，二级<font color='#01ADE7'>6</font>元 -->
  </div>
</template>

<script>
// import axios from 'axios'
// import cheerio from 'cheerio'

export default {
  name: "TestPC",
  data() {
    return {
      width: document.documentElement.clientWidth || document.body.clientWidth,
      height:
        document.documentElement.clientHeight || document.body.clientHeight,
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    fetch() {
      // 目标网站的URL
      const targetUrl = "https://www.baidu.com"; // 替换为你要爬取的金融网站的URL

      // 发起HTTP请求获取页面内容
      // axios.get(targetUrl)
      //   .then(response => {
      //     const html = response.data;
      //     const $ = cheerio.load(html);

      //     // 使用Cheerio选择器来提取你需要的数据
      //     const data = [];

      //     // 示例：假设目标页面上的数据在 class 为 "financial-data" 的元素中
      //     $('.title-content-title').each((index, element) => {
      //       const value = $(element).text();
      //       data.push(value);
      //     });

      //     // 打印爬取到的数据
      //     console.log(data);
      //   })
      //   .catch(error => {
      //     console.error('Error fetching the page:', error);
      //   });
    },
  },
};
</script>

<style scoped>
p {
  font-size: 18px;
  margin: 15px 0px 15px 0px;
  color: #3c3c3c;
  font-family: PingFangSC-Regular, sans-serif;
}
</style>
